import PropTypes from 'prop-types';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';

import { UpsellFauxLink } from './OrderTracker.styles';
import OrderTrackerItem from './OrderTrackerItem';
import { getUpsellItems } from './utils';

function OrderTrackerUpsells({ type }) {
  const { entitlements, businessEntityUuid } = useBusinessEntity();

  const eventObject = {
    elementName: 'order_tracking_upsell'
  };
  const upsells = getUpsellItems(type, entitlements);

  return (
    upsells?.map(({ entitlement, url, title }) => (
      <UpsellFauxLink key={entitlement} url={url.replace('{BUUID}', businessEntityUuid)}>
        <OrderTrackerItem
          color="secondary"
          type={entitlement}
          titleMessageId={title}
          ctaMessageId="dashboard.orderTracker.upsell.suggested"
          justifyContent="end"
          eventCallback={useLinkPressedCallback}
          eventObject={eventObject}
        />
      </UpsellFauxLink>
    )));
}

OrderTrackerUpsells.propTypes = {
  type: PropTypes.string.isRequired
};

export default OrderTrackerUpsells;
